import { redirect } from 'next/navigation';
import { getTradeOfferData } from '../../common';
import { NEXT_ROUTES } from '@bts-web/utils-next-infrastructure';
import { TradeControllerVariants } from '../utils';
import { AcceptTradeControllerVariants } from '../AcceptTrade/types';
import {
  AssetDetailByIdTitle,
  AssetDetailsControllerWithSuspense,
} from '../../asset-details';
import { AcceptTradeController } from '../AcceptTrade/AcceptTradeController';
import { AppMainLayoutWrapper } from '../../layouts/LayoutWithLeftDesktopNav/AppMainLayoutWrapper/AppMainLayoutWrapper';
import { AssetDetailTradeWrapper } from '../../layouts/AssetDetailTradeWrapper/AssetDetailTradeWrapper';

interface AcceptBackwardsCompatibilityInterceptorProps {
  tradeOfferID?: string;
  operation: TradeControllerVariants;
}

export const AcceptOfferBackwardsCompatibilityInterceptor = async ({
  tradeOfferID,
  operation,
}: AcceptBackwardsCompatibilityInterceptorProps) => {
  if (!tradeOfferID) {
    redirect(NEXT_ROUTES.ERROR_GENERIC);
  }

  const tradeOfferData = await getTradeOfferData(tradeOfferID);

  const assetId = tradeOfferData?.data?.tradeOffer?.asset?.id;

  if (!assetId || !tradeOfferID || !tradeOfferData?.data?.tradeOffer) {
    redirect(NEXT_ROUTES.ERROR_GENERIC);
  }

  return (
    <AppMainLayoutWrapper
      OverWriteTitleElement={<AssetDetailByIdTitle assetId={assetId} />}
      settings={{
        hideDesktopFooter: true,
        hideTopBarTradeButton: true,
      }}
    >
      <AssetDetailTradeWrapper
        startFocusValue={true}
        hideMobile="assetElement"
        AssetDetailsContent={
          <AssetDetailsControllerWithSuspense assetId={assetId} />
        }
        TradeStateContent={
          <AcceptTradeController
            offerData={tradeOfferData.data.tradeOffer}
            variant={operation as AcceptTradeControllerVariants}
          />
        }
      />
    </AppMainLayoutWrapper>
  );
};
